import ViewBase from "../../view-base.view";
import UserBadgeComponent from "../../../components/common/user-badge.component";
import assignScheduleModel from "../../../models/schedule/assign-schedule.model";
import loginModel from "../../../models/login.model";
import { Button, Icons, Intent, Size } from "construct-ui";
import { formats as FORMATS } from '../../../config/constants';
import moment from "moment";
import _ from "lodash";
import workTemplateModel from "../../../models/schedule/work-template.modal";

export default function AssignScheduleView() {

  ViewBase.call(this);

  let scheduleUserDetails;
  let siteList;
  let workTypeList;
  let templateList;
  let leaveTypeList;
  let dayOffTypeList;
  let specialTaskTypeList;
  let formData;
  let needRefresh = false;
  let isSendToJPO = false;
  let isSpecialTask = false;

  let isTodaySelected = () => {
    let todayString = moment().format(FORMATS.dateFormat); // YYYY.MM.DD
    if (assignScheduleModel.scheduleDateList && assignScheduleModel.scheduleDateList.includes(todayString)) {
      return true;
    } else {
      return false;
    }
  }

  let isEditableLeaveType = (workType) => {
    // If Today is selected, allows only LEAVE / DAY OFF
    if (isTodaySelected()) {
      return ['002', '003'].includes(workType.code); // 002 Leave & 003 Day off
    }
    return true;
  }

  let getWorkTypeList = () => {
    assignScheduleModel.getWorkTypeList(
      (result) => {
        // Populate workType list
        workTypeList = [];
        if (result) {
          result.filter(isEditableLeaveType).map(t => {
            workTypeList.push(t);
          });
        }
        // Set default value
        if (workTypeList.length > 0) {
          formData.workType = workTypeList[0].code;
          loadWorkTemplateList();
        }
      },
      (error) => {
        console.error("getWorkTypeList - error:", JSON.parse(JSON.stringify(error)));
      }
    )
  }

  let getSiteList = (countryCode, userId) => {
    this.showLoading();
    assignScheduleModel.getManagedSiteList(
      (result) => {
        // console.log('getManagedSiteList - result', result);
        siteList = [];
        siteList.push({
          siteCode: "",
          siteName: this.getText("LT00000201", "Please select"),
        });
        if (result) {
          result.map(s => {
            siteList.push(s);
          });
        }
        if (templateList) {
          this.hideLoading();
        }
      }, (error) => {
        this.hideLoading();
        console.error("getManagedSiteList - error:", JSON.parse(JSON.stringify(error)));
      }, {
      countryCode,
      userId
    }
    );
  }

  let getLeaveTypeList = () => {
    assignScheduleModel.getLeaveTypeList(
      (result) => {
        // console.log('getLeaveTypeList - result', result);
        leaveTypeList = [];
        leaveTypeList.push({
          code: '',
          name: this.getText("LT00000201", "Please select"),
        });
        if (result) {
          result.map(t => {
            leaveTypeList.push(t);
          });
        }
      },
      (error) => {
        console.error("getLeaveTypeList - error:", JSON.parse(JSON.stringify(error)));
      }
    )
  }

  let getDayOffTypeList = () => {
    assignScheduleModel.getDayOffTypeList(
      (result) => {
        // console.log('getDayOffTypeList - result', result);
        dayOffTypeList = [];
        dayOffTypeList.push({
          code: '',
          name: this.getText("LT00000201", "Please select"),
        });
        if (result) {
          result.map(t => {
            dayOffTypeList.push(t);
          });
        }
      },
      (error) => {
        console.error("getDayOffTypeList - error:", JSON.parse(JSON.stringify(error)));
      }
    )
  }

  let _getSpecialTaskTypeList = () => {
    workTemplateModel.getSpecIalTaskTypeList()
      .then((result) => {
        specialTaskTypeList = [];
        specialTaskTypeList.push({
          code: '',
          name: this.getText("LT00000201", "Please select"),
        });
        result.map((item) => {
          specialTaskTypeList.push(item)
        });
      })
      .catch((error) => {
        this.handleError(error);
      });;
  }

  let loadWorkTemplateList = () => {
    this.showLoading();
    assignScheduleModel.getWorkTemplateListByWorkType(
      (result) => {
        // console.log('loadWorkTemplateList - result', result);
        templateList = [];
        templateList.push({
          workTemplateId: 0,
          workTemplateName: this.getText("LT00000201", "Please select"),
        });
        if (result) {
          result.map(t => {
            templateList.push(t);
          });
        }
        if (siteList) {
          this.hideLoading();
        }
      }, (error) => {
        this.hideLoading();
        console.error("loadWorkTemplateList - error:", JSON.parse(JSON.stringify(error)));
      }
    );
  }

  let closeModal = function () {
    onClose(false);
  }

  let onClose = (isModalOpen) => { }

  let triggerRefresh = (needRefresh, isSendToJPO) => { }

  let saveSchedule = () => {
    if (isSpecialTask && !_checkFormValidation()) {
      this.showErrorMessage(this.getText('EM00000845', 'Please select a Special Task type'));
      return;
    }

    assignScheduleModel.assignSchedule(
      (result) => {
        // console.log("Changes saved!")
        if (scheduleUserDetails && scheduleUserDetails.userAccess && scheduleUserDetails.userAccess.jpoUser && result && Array.isArray(result) && result[0].code === '001') {
          isSendToJPO = true;
          this.showMessage('There is change(s) to JPO Schedule. Please click on the "Send to JPO" button to send the latest schedules to JPO engine.', null, () => { onClose(false); });
        } else {
          onClose(false);
        }
        needRefresh = true;
        // onClose(false);
      },
      (error) => {
        // Reset submitted form data
        assignScheduleModel.resetFormDataList();
        this.handleError(error);
      }
    );

  }

  let _checkIsSpecialTask = (type) => {
    isSpecialTask = type == "007" ? true : false;
  }

  let _checkFormValidation = () => {
    if (!formData.leaveDayOffType) {
      return false;
    }
    return true;
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onClose) {
        onClose = vnode.attrs.onClose;
      }
      if (vnode.attrs.triggerRefresh) {
        triggerRefresh = vnode.attrs.triggerRefresh;
      }
      scheduleUserDetails = vnode.attrs.scheduleUserDetails;
      // console.log('scheduleUserDetails=========>', scheduleUserDetails)
      formData = assignScheduleModel.formData;
      formData.userID = scheduleUserDetails.userId;
      assignScheduleModel.scheduleDateList = scheduleUserDetails.scheduleDates;
      getWorkTypeList();
      getSiteList(loginModel.credentials.country, formData.userID);
      getLeaveTypeList();
      getDayOffTypeList();
      _getSpecialTaskTypeList();
    },
    oncreate: (vnode) => {
    },
    onremove: (vnode) => {
      triggerRefresh(needRefresh, isSendToJPO);
      assignScheduleModel.resetFormDataList();
      assignScheduleModel.resetFormData();
    },
    view: (vnode) => {
      return m('.assign-schedule', { style: 'max-width: 520px;' },
        // User badge
        scheduleUserDetails &&
        m('.row',
          m('.col-10.offset-1.col-sm-8.offset-sm-2.mt-3',
            m(UserBadgeComponent, {
              image: scheduleUserDetails.photoString,
            },
              m('.user-text-md', scheduleUserDetails.userName),
            ),
          ),
        ),
        m('hr'),
        m('nav',
          m('.nav.nav-tabs.flex-row.justify-content-start#nav-tabs[role="tablist"]',
            m('button.nav-item.nav-link.active#nav-template-tab[data-bs-toggle="tab"][data-bs-target="#nav-template"][aria-controls="nav-template"][type="button"][role="tab"][aria-selected="true"]', this.getText("LT00000202", "Template")),
            m('button.nav-item.nav-link#nav-manual-tab[data-bs-toggle="tab"][data-bs-target="#nav-manual"][aria-controls="nav-manual"][type="button"][role="tab"][aria-selected="false"]',
              {
                onclick: e => formData.workTemplateID = 0
              },
              this.getText("LT00000203", "Manual")
            ),
          )
        ),
        m('.tab-content#nav-tabContent',
          m('.tab-pane.fade.show.active#nav-template[role="tabpanel"][aria-labelledby="nav-template-tab"]',
            // # TEMPLATE
            m('.row.g-3',
              m('.col-8.offset-2.col-sm-12.offset-sm-0',
                m('.row.g-sm-4.align-items-center',
                  m('.col-sm-3.text-sm-end',
                    m('label', this.getText("LT00000132", "Date")),
                  ),
                  m('.col-sm-7',
                    assignScheduleModel.displayScheduleDates()
                  ),
                )
              ),
              m('.col-8.offset-2.col-sm-12.offset-sm-0',
                m('.row.g-sm-4.align-items-center',
                  m('.col-sm-3.text-sm-end',
                    m('label[for=workType]', this.getText("LT00000149", "Work Type"))
                  ),
                  m('.col-sm-7',
                    m('select#workType.form-select', {
                      value: formData.workType,
                      onchange: (e) => {
                        formData.workType = workTypeList[e.target.selectedIndex].code;
                        _checkIsSpecialTask(formData.workType);
                        loadWorkTemplateList();
                        // Clear
                        assignScheduleModel.onWorkTypeChange();
                      }
                    },
                      workTypeList && workTypeList.map(wt => [
                        m('option', {
                          value: wt.code,
                          selected: formData.workType == wt.code
                        },
                          wt.name
                        )
                      ])
                    )
                  ),
                )
              ),
              // isSpecialTask && // Special Task
              // m('.col-8.offset-2.col-sm-12.offset-sm-0',
              //   m('.row.g-sm-4.align-items-center',
              //     m('.col-sm-3.text-sm-end',
              //       m('label[for=specialTaskType]', this.getText("LT00001340", "Special Task Type"), m('span.redText', "*"))
              //     ),
              //     m('.col-sm-7',
              //       m('select#specialTaskType.form-select',
              //         {
              //           value: formData.leaveDayOffType,
              //           onchange: (e) => {
              //             formData.leaveDayOffType = leaveTypeList[e.target.selectedIndex].code;
              //           }
              //         },
              //         specialTaskTypeList && specialTaskTypeList.map(t => [
              //           m('option', {
              //             value: t.code,
              //             selected: formData.leaveDayOffType == t.code
              //           },
              //             t.name
              //           )
              //         ])
              //       )
              //     ),
              //   )
              // ),
              formData.workType === '001' &&
              m('.col-8.offset-2.col-sm-12.offset-sm-0',
                m('.row.g-sm-4.align-items-center',
                  m('.col-sm-3.text-sm-end',
                    m('label[for=siteCode]', this.getText("LT00000071", "Site"))
                  ),
                  m('.col-sm-7',
                    m('select#siteCode.form-select', {
                      value: formData.siteId,
                      onchange: (e) => {
                        formData.siteId = siteList[e.target.selectedIndex].siteCode
                      }
                    },
                      siteList && siteList.map(site => [
                        m('option', {
                          value: site.siteCode,
                          selected: site.siteCode == formData.siteId
                        },
                          site.siteName
                        )
                      ])
                    )
                  ),
                )
              ),
              templateList &&
              m('.col-8.offset-2.col-sm-12.offset-sm-0',
                m('.row.g-sm-4.align-items-center',
                  m('.col-sm-3.text-sm-end',
                    m('label[for=template]', this.getText("LT00000202", "Template"))
                  ),
                  m('.col-sm-7',
                    m('select#template.form-select', {
                      value: formData.workTemplateID,
                      onchange: (e) => {
                        if (!_.isEmpty(templateList)) {
                          formData.workTemplateID = templateList[e.target.selectedIndex].workTemplateId;
                          formData.startTime = templateList[e.target.selectedIndex].startTime;
                          formData.endTime = templateList[e.target.selectedIndex].endTime;
                          formData.breakHour = templateList[e.target.selectedIndex].breakHour;
                          formData.remarks = templateList[e.target.selectedIndex].remarks;
                        }
                      }
                    },
                      templateList && templateList.map(t => [
                        m('option', {
                          value: t.workTemplateId,
                          selected: t.workTemplateId == formData.workTemplateID
                        },
                          t.workTemplateName
                        )
                      ])
                    )
                  ),
                )
              ),
            ),
          ),
          m('.tab-pane.fade#nav-manual[role="tabpanel"][aria-labelledby="nav-manual-tab"]',
            // # MANUAL
            m('.row.g-3',
              m('.col-8.offset-2.col-sm-12.offset-sm-0',
                m('.row.g-sm-4.align-items-center',
                  m('.col-sm-3.text-sm-end',
                    m('label', this.getText("LT00000132", "Date")),
                  ),
                  m('.col-sm-7',
                    assignScheduleModel.displayScheduleDates()
                  ),
                )
              ),
              // Field: Work Type
              m('.col-8.offset-2.col-sm-12.offset-sm-0',
                m('.row.g-sm-4.align-items-center',
                  m('.col-sm-3.text-sm-end',
                    m('label[for=workType]', this.getText("LT00000149", "Work Type"))
                  ),
                  m('.col-sm-7',
                    m('select#workType.form-select',
                      {
                        value: formData.workType,
                        onchange: (e) => {
                          formData.workType = workTypeList[e.target.selectedIndex].code;
                          _checkIsSpecialTask(formData.workType);
                          loadWorkTemplateList();
                          // Clear
                          assignScheduleModel.onWorkTypeChange();
                        }
                      },
                      workTypeList && workTypeList.map(wt => [
                        m('option', {
                          value: wt.code,
                          selected: formData.workType == wt.code
                        },
                          wt.name
                        )
                      ])
                    )
                  ),
                )
              ),
              // Field: Sub-type (Special Task type)
              isSpecialTask && // Special Task
              m('.col-8.offset-2.col-sm-12.offset-sm-0',
                m('.row.g-sm-4.align-items-center',
                  m('.col-sm-3.text-sm-end',
                    m('label[for=specialTaskType]', this.getText("LT00001340", "Special Task Type"), m('span.redText', "*"))
                  ),
                  m('.col-sm-7',
                    m('select#specialTaskType.form-select',
                      {
                        value: formData.leaveDayOffType,
                        onchange: (e) => {
                          formData.leaveDayOffType = leaveTypeList[e.target.selectedIndex].code;
                        }
                      },
                      specialTaskTypeList && specialTaskTypeList.map(t => [
                        m('option', {
                          value: t.code,
                          selected: formData.leaveDayOffType == t.code
                        },
                          t.name
                        )
                      ])
                    )
                  ),
                )
              ),
              // Field: Site
              formData.workType === '001' && // Work
              m('.col-8.offset-2.col-sm-12.offset-sm-0',
                m('.row.g-sm-4.align-items-center',
                  m('.col-sm-3.text-sm-end',
                    m('label[for=siteCode]', this.getText("LT00000071", "Site"))
                  ),
                  m('.col-sm-7',
                    m('select#siteCode.form-select', {
                      value: formData.siteId,
                      onchange: (e) => {
                        formData.siteId = siteList[e.target.selectedIndex].siteCode
                      }
                    },
                      siteList && siteList.map(site => [
                        m('option', {
                          value: site.siteCode,
                          selected: site.siteCode == formData.siteId
                        },
                          site.siteName
                        )
                      ])
                    )
                  ),
                )
              ),
              m('hr.mt-4.mb-2'),
              // Field: Leave Type
              formData.workType === '002' && // Leave
              m('.col-8.offset-2.col-sm-12.offset-sm-0',
                m('.row.g-sm-4.align-items-center',
                  m('.col-sm-3.text-sm-end',
                    m('label[for=leaveType]', this.getText("LT00000160", "Leave Type"))
                  ),
                  m('.col-sm-7',
                    m('select#leaveType.form-select',
                      {
                        value: formData.leaveDayOffType,
                        onchange: (e) => {
                          formData.leaveDayOffType = leaveTypeList[e.target.selectedIndex].code;
                        }
                      },
                      leaveTypeList && leaveTypeList.map(t => [
                        m('option', {
                          value: t.code,
                          selected: formData.leaveDayOffType == t.code
                        },
                          t.name
                        )
                      ])
                    )
                  ),
                )
              ),
              // Field: Day Off Type
              formData.workType === '003' && // Day Off
              m('.col-8.offset-2.col-sm-12.offset-sm-0',
                m('.row.g-sm-4.align-items-center',
                  m('.col-sm-3.text-sm-end',
                    m('label[for=dayOffType]', this.getText("LT00000204", "Day Off Type"))
                  ),
                  m('.col-sm-7',
                    m('select#dayOffType.form-select',
                      {
                        value: formData.leaveDayOffType,
                        onchange: (e) => {
                          formData.leaveDayOffType = dayOffTypeList[e.target.selectedIndex].code;
                        }
                      },
                      dayOffTypeList && dayOffTypeList.map(t => [
                        m('option', {
                          value: t.code,
                          selected: formData.leaveDayOffType == t.code
                        },
                          t.name
                        )
                      ])
                    )
                  ),
                )
              ),
              // Field: Start / End Time
              formData.workType !== '006' && // When Work Type is not Others
              !(formData.workType === '002' && !(formData.leaveDayOffType === '002' || formData.leaveDayOffType === '003')) && // When Leave Type is not AM / PM
              !(formData.workType === '003' && !(formData.leaveDayOffType === '002' || formData.leaveDayOffType === '003')) && // When Day Off Type is not AM / PM
              m('.col-8.offset-2.col-sm-12.offset-sm-0',
                m('.row.g-sm-4.align-items-center',
                  m('.col-sm-3.text-sm-end',
                    formData.workType === '001' // Work
                      ? m('label', this.getText("LT00000182", "Working Hours"))
                      : formData.workType === '004'  // Training
                        ? m('label', this.getText("LT00000205", "Training Time"))
                        // Leave, Day-Off, Road Show
                        : m('label', this.getText("LT00000206", "Time"))
                  ),
                  m('.col-sm-7',
                    [
                      m('.d-flex.align-items-center', { style: 'gap: 1em;' },
                        m('.flex-grow-1',
                          m('input.form-control[type=time]', {
                            value: formData.startTime,
                            onchange: e => formData.startTime = e.target.value
                          }),
                        ),
                        m('.text-center', { style: 'width: 1.5em;' }, ' ~ '),
                        m('.flex-grow-1',
                          m('input.form-control[type=time]', {
                            value: formData.endTime,
                            onchange: e => formData.endTime = e.target.value
                          }),
                        ),
                      ),
                    ]
                  ),
                )
              ),
              // Field: Break Hours
              formData.workType === '001' && // Work
              m('.col-8.offset-2.col-sm-12.offset-sm-0',
                m('.row.g-sm-4.align-items-center',
                  m('.col-sm-3.text-sm-end',
                    m('label', this.getText("LT00000207", "Break Hours"))
                  ),
                  m('.col-sm-7',
                    m('.d-flex.align-items-center', { style: 'gap: 1em;' },
                      m('.flex-grow-1',
                        m('input.form-control[type=number][inputmode=numeric]', {
                          value: formData.hourOfBreakHour,
                          onchange: e => {
                            formData.hourOfBreakHour = e.target.value;
                          }
                        }),
                      ),
                      m('.text-center', { style: 'width: 1.5em;' }, ' : '),
                      m('.flex-grow-1',
                        m('input.form-control[type=number][inputmode=numeric]', {
                          value: formData.minuteOfBreakHour,
                          onchange: e => {
                            formData.minuteOfBreakHour = e.target.value;
                          }
                        }),
                      ),
                    ),
                  ),
                )
              ),
              // Field: Remarks / Place
              formData.workType !== '002' && formData.workType !== '003' && // Not 'Leave' / 'Day Off'
              m('.col-8.offset-2.col-sm-12.offset-sm-0',
                m('.row.g-sm-4.align-items-center',
                  m('.col-sm-3.text-sm-end',
                    formData.workType === '001' // Work
                      ? m('label', this.getText("LT00000152", "Remarks"))
                      // Not 'Work'
                      : m('label', this.getText("LT00000162", "Remarks / Place"))
                  ),
                  m('.col-sm-7',
                    m('textarea.form-control', {
                      onchange: e => {
                        formData.remarks = e.target.value;
                      }
                    })
                  ),
                )
              ),
            ),
          ),
        ),
        m('.d-flex.justify-content-end.mb-1.mt-4', { style: 'gap: 0.75em' },
          m(Button, {
            intent: Intent.PRIMARY,
            label: this.getText("LT00000022", "Save"),
            onclick: saveSchedule
          }),
          m(Button, {
            outlined: true,
            label: this.getText("LT00000021", "Close"),
            onclick: closeModal
          })
        ),
        this.getBaseViews()
      )
    }
  }
}